<template>
  <!-- 新增商保 -->
  <div class="page_addCin">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item>信息维护</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/israGudSet' }">保险维护</el-breadcrumb-item>
          <el-breadcrumb-item>商保新增/编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="cinForm">
          <el-form :model="cinForm" :rules="rules" ref="cinForm" label-width="110px">
            <el-form-item label="服务商名称" prop="ServerName">
              <el-input v-model="cinForm.ServerName"></el-input>
            </el-form-item>
            <el-form-item label="商保方案名称" prop="ProjectName">
              <el-input v-model="cinForm.ProjectName"></el-input>
            </el-form-item>
            <el-form-item label="商保类别" prop="Bntype">
              <el-select v-model="cinForm.Bntype" placeholder="" clearable>
                <el-option v-for="(item, index) in bntList" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="投保金额(元)" prop="Price">
              <el-input v-model="cinForm.Price"></el-input>
            </el-form-item>
            <el-form-item label="理赔上限(元)" prop="ClaimsPrice">
              <el-input v-model="cinForm.ClaimsPrice"></el-input>
            </el-form-item>
            <el-form-item label="工种类型" prop="TypeWork">
              <el-select v-model="cinForm.TypeWork" placeholder="" clearable multiple>
                <el-option value="一类"></el-option>
                <el-option value="二类"></el-option>
                <el-option value="三类"></el-option>
                <el-option value="四类"></el-option>
                <el-option value="五类"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="对接人" prop="ContactPerson">
              <el-select v-model="cinForm.ContactPerson" value-key="Userid" placeholder="" clearable filterable @change="val => { changePerson(val, 'ContactPerson', 'ContactPersonID') }">
                <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="说明" prop="Remark">
              <el-input type="textarea" v-model="cinForm.Remark" :autosize="{ minRows: 4 }" maxlength="500" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="附件" prop="name1">
              <div class="upload_box">
                <el-upload class="upload-demo" action="" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
                  <el-button size="small" type="success">上传附件</el-button>
                </el-upload>
              </div>
            </el-form-item>

            <div class="btnBox">
              <el-button type="success" @click="submitForm" v-preventReClick>保存</el-button>
              <el-button @click="backHandle">取消</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        cinForm: {
          ServerName: '', //服务商名称
          ProjectName: '', //商保方案名称
          Bntype: '', //商保类别
          Price: '', //投保金额
          ContactPerson: '', //对接人
          ContactPersonID: '',
          AttachmentUrl: '',
          ClaimsPrice: '', //理赔上限
          TypeWork: '', //工种类型
        },
        rules: {
          // ServerName: {
          //   required: true,
          //   message: "请输入服务商名称",
          //   trigger: "blur",
          // },
          // ProjectName: {
          //   required: true,
          //   message: "请输入商保方案名称",
          //   trigger: "blur",
          // },
          // Price: {
          //   required: true,
          //   message: "请输入投保金额",
          //   trigger: "blur",
          // }
        },
        fileList: [],
        headPath: this.$store.state.EMP.docPath,
        personnelList: [], //人员列表
        roletype: localStorage.loginRoletype,
        bntList: ['30万小商保', '60万大商保', '90万大小商保', '50万商保（超龄人员保安保洁岗位）', '30万小商保（建筑业）', '60万大商保（建筑业）', '90万大小商保（建筑业）', '90万日商保（1-4类）', '100万雇主责任险', '30万新业态伤害险', '60万新业态伤害险', '90万新业态伤害险', '源和健康险']
      };
    },
    created() {
      if (this.$route.query.row != undefined && this.$route.query.row) {
        console.log(JSON.parse(this.$route.query.row))
        this.cinForm = JSON.parse(this.$route.query.row)
        if (this.cinForm.AttachmentUrl) {
          let item = {
            Id: new Date().valueOf().toString() + Math.random(),
            name: this.cinForm.AttachmentUrl,
            url: this.headPath + this.cinForm.AttachmentUrl
          }
          this.fileList = [item]
        }
        if (this.cinForm.TypeWork != undefined && this.cinForm.TypeWork) {
          this.cinForm.TypeWork = this.cinForm.TypeWork.split(',')
        }
      }
      this.getauthUserInfoByorgancode()
    },
    methods: {
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      //取人员列表
    getauthUserInfoByorgancode() {
      let data = {
        currpage: 1,
        perpage: 10000000,
        keyword: "",
        strWorkState: "在职",
        strstation: "",
        strorgancode: ""
      }
      xz.getauthUserInfoByorgancode(data).then(res => {
        if (res.status == "ok") {
          this.personnelList = res.msg;
        } else {
          this.$message.error('获取人员列表失败')
          this.personnelList = [];
        }
      })
    },
      //上传附件
      success_handle(file, fileList) {
        console.log(file, fileList);
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.cinForm.AttachmentUrl = res
          } else {
            this.cinForm.AttachmentUrl = ''
          }
        });
      },
      handleRemove(file) {
        this.cinForm.AttachmentUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      submitForm() {
        this.$refs["cinForm"].validate((valid) => {
          if (valid) {
            if (this.cinForm.TypeWork) {
              this.cinForm.TypeWork = this.cinForm.TypeWork.toString();
            }
            xz.updatebi(this.cinForm).then(res => {
              if (res.status == 'ok') {
                if (this.cinForm.TypeWork != undefined && this.cinForm.TypeWork) {
                  this.cinForm.TypeWork = this.cinForm.TypeWork.split(',')
                }
                this.$message.success('保存成功')
                setTimeout(() => {
                  this.backHandle()
                }, 300);
              } else {
                this.$message.error('系统出错')
              }
            })
          }
        })
      },
      //选择人员
      changePerson(val, name, id) {
        this.cinForm[id] = val.Userid;
        this.cinForm[name] = val.Username;
      },
      // 取消
      backHandle() {
        // window.close()
        this.$router.push({
          path: "/israGudSet",
        });
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
  }

  .upload_box {
    width: 300px;
  }

  .btnBox {
    margin-top: 20px;
    padding: 20px 0 50px 0;
    width: 320px;
    display: flex;
    justify-content: center;
  }
</style>
<style>
  .cinForm .el-input__inner {
    width: 221px;
  }

  .page_addCin .el-textarea__inner,
  .page_addCin .el-textarea {
    width: 500px;
  }
</style>